import React from "react";
import style from "../styles/experience.module.css";
import { motion } from "framer-motion";
import Reveal from "../components/reveal";
import { TbBriefcase, TbCircleCheck } from "react-icons/tb";
import { TechIcon } from "../components/techIcons";
import { experience } from "../data/profile";

const Experience = () => (
  <section id="experience" className={`sectionShell ${style.experience}`}>
    <div className="sectionInner">
      <Reveal dir="up" amount={0.4}>
        <h2 className="sectionHeading" data-outline="Experience">
          Experience
        </h2>
      </Reveal>

      <div className={style.timeline}>
        <span className={style.spine} aria-hidden="true" />

        {experience.map((job, ji) => (
          <Reveal
            dir="up"
            delay={ji * 0.08}
            amount={0.1}
            key={job.id}
            className={style.entry}
          >
            <motion.span
              className={style.marker}
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ type: "spring", stiffness: 320, damping: 18 }}
            >
              <TbBriefcase />
            </motion.span>

            <motion.article
              className={`experience-card ${style.card}`}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
            >
              <div className={style.head}>
                <div className={style.headText}>
                  <h3 className={style.role}>
                    {job.role}
                    {job.altRole && (
                      <span className={style.altRole}>{job.altRole}</span>
                    )}
                  </h3>
                  <p className={style.company}>{job.company}</p>
                </div>
                <div className={style.periodWrap}>
                  <span className={style.period}>{job.period}</span>
                  {job.current && <span className={style.badge}>Latest</span>}
                </div>
              </div>

              <ul className={style.points}>
                {job.points.map((point, ind) => (
                  <motion.li
                    key={ind}
                    initial={{ opacity: 0, x: -12 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.4, delay: 0.05 * ind }}
                  >
                    <TbCircleCheck className={style.tick} />
                    <span>{point}</span>
                  </motion.li>
                ))}
              </ul>

              <div className={style.stack}>
                {job.stack.map((tech) => (
                  <span key={tech} className={style.chip}>
                    <TechIcon name={tech} /> {tech}
                  </span>
                ))}
              </div>
            </motion.article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Experience;
